// IE 2026 10 13 / ODOO-5800 (бот dev02 bot_save2, часть B: секция «Responsibles» рисовалась внутри DETAILS · MOVEMENTS): чистая группировка секций паспорта ячейки по блокам
// формы — без Vue и DOM (юнит-тест tests/unit/passportBlocks.test.mjs). Секция паспорта бэка (cell_passport.sections) — {kind, title, rows, summary, placement?}.
// Прежнее правило: kind 'approval' — блок APPROVAL (fe.cellForm.lbeApproval), kind 'stock' — блоки STOCK / WHY THIS PLAN, все остальные — DETAILS · MOVEMENTS.
// Новое: секция с placement === 'after_problems' (бэк be-ie, PR #174) — самостоятельный блок сразу после блока PROBLEMS; ключ секции FE не знает (блок общий для любой такой секции).
// Выключатель fe.passport.responsiblesBlock (afterOn; false — прежнее место: секция остаётся среди движений).
export const PLACEMENT_AFTER_PROBLEMS = 'after_problems'

export function passportSections_group(secs, opts) {
    const o = opts || {}
    const list = Array.isArray(secs) ? secs.filter(x => x) : []
    const isAfter = x => !!o.afterOn && x.placement === PLACEMENT_AFTER_PROBLEMS && x.kind !== 'stock' && x.kind !== 'approval'
    return {
        appr: o.apprOn ? list.filter(x => x.kind === 'approval') : [],
        after: list.filter(isAfter),
        docs: list.filter(x => x.kind !== 'stock' && x.kind !== 'approval' && !isAfter(x)),
        stock: list.filter(x => x.kind === 'stock'),
    }
}

// Блоки «после PROBLEMS»: по одному на секцию (свой заголовок, своя сводка в свёрнутом виде); ключ — 'after:<kind>' (kind секции; нет — порядковый номер)
export function passportAfterBlocks(after) {
    return (after || []).map((s, i) => ({ key: 'after:' + (s.kind || i), title: String(s.title || s.title_en || s.kind || ''), sections: [s], summary: String(s.summary || '') }))
}
